module.exports = __webpack_public_path__ + "fonts/Latinka-Medium.4929f000.ttf";